export default "__VITE_ASSET__DQgTpAXH__"